/* IMPORTS ------------------------------------------------------------------------------------- */
// PLUGINS
import { v4 as uuid } from 'uuid';
import { derived, writable } from 'svelte/store';
/* CONFIG -------------------------------------------------------------------------------------- */
const DURATION_IN_SECONDS = 6;
const DURATION = DURATION_IN_SECONDS * 1000;
/* INTERFACES --------------------------------------------------------------------------------- */
export const UNDO = writable({});
const removeUndo = (key) => {
    UNDO.update(store => {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete store[key];
        return store;
    });
};
const executeAction = async ({ isAborted, action, key, timeout, interval }) => {
    clearTimeout(timeout);
    clearInterval(interval);
    if (!isAborted) {
        await action();
    }
    removeUndo(key);
};
export const abortUndo = (key) => {
    UNDO.update(store => {
        clearTimeout(store[key].timeout);
        clearInterval(store[key].interval);
        store[key].isAborted = true;
        return store;
    });
};
// eslint-disable-next-line max-lines-per-function
export const addUndo = (message) => {
    const ITEM = {
        ...message,
        isAborted: false,
        key: uuid(),
        progress: 0,
        timeout: setTimeout(() => {
            void executeAction(ITEM);
        }, DURATION),
    };
    ITEM.interval = setInterval(() => {
        UNDO.update(store => {
            store[ITEM.key].progress += 0.5;
            return store;
        });
    }, 0.5 * (DURATION / 100));
    UNDO.update(store => {
        store[ITEM.key] = ITEM;
        return store;
    });
};
export const UNDO_LIST = derived(UNDO, $UNDO => Object.values($UNDO));
